import gql from 'graphql-tag';
import { AccountClient, log } from '@emyw/core-lib';
import { GetAuthenticatedUserId, LogOut } from '@emyw/auth-lib';
import * as types from './actionTypes';
import initialState from '../reducers/initialState';

export const loadUserSuccess = user => ({ type: types.SET_USER_SUCCESS, user });
export const loadUserFailure = () => ({ type: types.SET_USER_FAILURE, user: initialState.user });

const getUserDetailQuery = gql`
    query ($userId: Int!) {
        getUserDetail(userId: $userId) {
            id
            userId
            email
            firstName
            lastName
            subscriptionLevelId
            subscriptionLevelCode
            subscriptionLevelName
            subscriptionLevelDescription
            subscriptionLevelDescriptionLong
            subscriptionLevelMonthlyCostFormatted
            timeZone
            zipCode
            paymentMethod
            signupCompletedOn
            verifiedOn
            promotionCode
            promotionCodeDescription
            ok
            errors {
                path
                message
            }
        }
    }
`;

export const loadUser = fetchPolicy => (
    dispatch => GetAuthenticatedUserId().then(async (userId) => {
        let user;
        if (userId > 0) {
            await AccountClient.query({
                query: getUserDetailQuery,
                variables: { userId },
                fetchPolicy: !fetchPolicy ? 'cache-first' : fetchPolicy,
            }).then((response) => {
                const { ok, errors } = response.data.getUserDetail;
                if (ok) {
                    try {
                        // dispatch(loadUserSuccess(response.data.getUserDetail));
                        user = loadUserSuccess(response.data.getUserDetail);
                    } catch (err) {
                        log.trace(err);
                        LogOut();
                        // dispatch(loadUserFailure());
                        user = loadUserFailure();
                    }
                } else {
                    log.trace(errors);
                    // dispatch(loadUserFailure());
                    user = loadUserFailure();
                }
            }).catch((error) => { // (error)
                /** If we experience an error here, then it is indicating that the user in the token is
                 * not found at the server, so we are in an unstable state and should logout to clear
                 * the invalid access tokens.
                 */
                log.trace(error);
                LogOut();
                // dispatch(loadUserFailure());
                user = loadUserFailure();
            });
        } else {
            /* There was no authenticated user */
            // dispatch(loadUserFailure());
            user = loadUserFailure();
        }
        // log.trace(`${user.type}:`, user.user);
        dispatch(user);
    })
);

export const logOut = () => {
    LogOut();
    return { type: types.LOGOUT_SUCCESS, user: initialState.user };
};
